import React from 'react';


export default function MainCard({ children, className, noShadow = false }) {
    return (
        <div className={`bg-white p-3 mt-3 rounded ${noShadow ? "" : "shadowFicha"} ${className}`}>
            {children}
        </div>
    )
}